module.exports = __webpack_public_path__ + "img/security.8bd0c645.svg";